/**
 * LowStockAlerts — what to reorder.
 *
 * Deliberately not a chart. These are states, not magnitudes: the question is
 * "which of these do I buy today", and a list answers it in less space than any
 * plot would. Status colour carries the state and is paired with a word, never
 * colour alone.
 */
import { useNavigate } from 'react-router-dom';
import { Card } from '@/components/ui/Card';
import { Qty } from '@/components/ui/numeric';

export interface StockAlert {
  productId: string;
  name: string;
  stock: number;
  unit: string | null;
  outOfStock: boolean;
}

export function LowStockAlerts({ items }: { items: StockAlert[] }) {
  const navigate = useNavigate();

  return (
    <Card className="p-5">
      <div className="mb-1 flex items-baseline justify-between gap-3">
        <h2 className="text-heading font-medium text-fg-primary">Low stock alerts</h2>
        {items.length > 0 && (
          <button
            type="button"
            onClick={() => navigate('/inventory')}
            className="text-label text-accent-ink hover:underline"
          >
            View all
          </button>
        )}
      </div>
      <p className="mb-4 text-label text-fg-tertiary">
        {items.length > 0 ? 'At or below their reorder level' : 'Nothing needs reordering'}
      </p>

      {items.length === 0 ? (
        <p className="text-body text-fg-tertiary">Every tracked product is above its reorder level.</p>
      ) : (
        <ul className="space-y-2.5">
          {items.map((p) => (
            <li key={p.productId} className="flex items-center justify-between gap-3 text-body">
              <span className="truncate text-fg-primary">{p.name}</span>
              <span className="shrink-0">
                {p.outOfStock ? (
                  <span className="font-medium text-danger-ink">Out of stock</span>
                ) : (
                  <span className="text-warning-ink">
                    <Qty value={p.stock} unit={p.unit} className="font-medium" /> left
                  </span>
                )}
              </span>
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
}
